export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.operation-desk': '操作台',
  'menu.operation-desk.operation-desk': '操作台',
  'menu.operation-desk.comprehensive': '综合统计',
  'menu.dashboard': '操作台',
  'menu.statistics': '统计分析',
  'menu.comprehensive': '综合统计',
  'menu.statistics.comprehensive': '综合统计',
  'menu.content-analysis': '内容分析',
  'menu.statistics.content-analysis': '内容分析',
  'menu.school-analysis': '院校分析',
  'menu.statistics.school-analysis': '院校分析',
  'menu.notification-management': '通知管理',
  'menu.notification-management.inbox': '收件箱',
  'menu.notification-management.send-notification': '发起通知',
  'menu.notification-management.send-history': '发送历史',
  'menu.notification': '通知管理',
  'menu.inbox': '收件箱',
  'menu.send-notification': '发起通知',
  'menu.send-history': '发送历史',
  'menu.content-management': '内容管理',
  'menu.content-management.abnormal-content': '异常内容',
  'menu.content-management.all-content': '全部内容',
  'menu.content-management.content-analysis': '内容分析',
  'menu.content': '内容管理',
  'menu.abnormal-content': '异常内容',
  'menu.all-content': '全部内容',
  'menu.personal': '个人中心',
  'menu.personal.user-info': '用户信息',
  'menu.personal.sub-account': '添加子账号',
  'menu.personal.change-password': '修改密码',
  'menu.user-info': '用户信息',
  'menu.sub-account': '子账号管理',
  'menu.change-password': '修改密码',
  'menu.account': '账号管理',
  'menu.account.school-account': '院校账号',
  'menu.account.education-account': '教委账号',
  'menu.account.media-account': '媒体账号',
  'menu.account.school-analysis': '院校分析',
  'menu.school-account': '院校账号',
  'menu.education-account': '教委账号',
  'menu.media-account': '媒体账号',
  'menu.platform-settings': '平台设置',
  'menu.platform-settings.abnormal-data': '异常数据字库',
  'menu.platform-settings.tag-library': '账号标签字库',
  'menu.platform-settings.role-management': '角色管理',
  'menu.platform-settings.operation-log': '操作日志',
  'menu.platform-settings.system-config': '系统配置',
  'menu.platform-settings.help-document': '帮助文档管理',
  'menu.platform-settings.school-tag-management': '打标签管理',
  'menu.platform-settings.article-pull-cache': '文章同步管理',
  'menu.help': '帮助中心',
  'menu.help.document': '帮助文档',
  'menu.document-view': '帮助文档',
  'menu.test-tools': '测试工具',
  'menu.test-tools.content-test': '文章测试',
  'menu.test-tools.account-relation-test': '单位关系测试',
  // 平台设置子菜单翻译
  'menu.abnormal-data': '异常数据字库',
  'menu.tag-library': '账号标签字库',
  'menu.role-management': '角色管理',
  'menu.operation-log': '操作日志',
  'menu.help-document': '帮助文档管理',
};
